import { APP_UTILITIES_EVENTS } from '../constants/actionTypes';

export const initialState = {
  transparentBackground: false,
};

const appUtilitiesReducer = (state, { type, payload }) => {
  switch (type) {
    case APP_UTILITIES_EVENTS.SET: {
      return { ...state, loading: false, ...payload };
    }

    case APP_UTILITIES_EVENTS.RESET:
      return initialState;

    default:
      return state;
  }
};

export default appUtilitiesReducer;
